import { render } from "./LinkReport.vue?vue&type=template&id=9dc3b78c"
import script from "./LinkReport.vue?vue&type=script&lang=js"
export * from "./LinkReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__